"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PhoneInfo = /** @class */ (function () {
    function PhoneInfo(source) {
        this.phoneId = source ? source.phoneId : -1;
        this.phoneNumber = source ? source.phoneNumber : '';
        this.extensionNumber = source ? source.extensionNumber : '';
    }
    return PhoneInfo;
}());
exports.PhoneInfo = PhoneInfo;
//# sourceMappingURL=PhoneInfo.js.map